import { numberFormatter, makeCurrencyFormatter } from "./numbers"

export function getTrendsExposureFormatters(isSensitivityContentSet, currency) {
  if (isSensitivityContentSet) {
    return {
      detailsFormatter: makeCurrencyFormatter(currency, { displayCurrencySymbol: false }),
      tickFormat: { tickFormat: makeCurrencyFormatter(currency, { fractionDigits: 1, displayCurrencySymbol: false }) },
      tooltipFormatter: makeCurrencyFormatter(currency, { fractionDigits: 1, displayCurrencySymbol: true }),
    }
  }
  return {
    detailsFormatter: numberFormatter,
    tickFormat: {},
    tooltipFormatter: numberFormatter,
  }
}
